import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import bezierCurveIcon from 'images/discover/datasets/bezier-curve.svg'
import cubeOutlineIcon from 'images/discover/datasets/cube-outline.svg'
import sparklesIcon from 'images/discover/datasets/sparkles.svg'

const STEP_ICONS = [cubeOutlineIcon, bezierCurveIcon, sparklesIcon]

function About({ about }) {
  return (
    <section className="datasets-about">
      <div className="discover-container">
        <h2 className="datasets-section-title discover-heading cgt-heading-500">{about.title}</h2>
        <ul className="datasets-about__cards">
          {about.steps.map((step, index) => (
            <li key={step.title} className="datasets-about__card">
              <img src={STEP_ICONS[index]} alt="" width={40} height={40} loading="lazy" />
              <h3 className="datasets-about__card-title discover-heading cgt-heading-200">{step.title}</h3>
              <p className="datasets-about__card-text cgt-body-md">{step.text}</p>
            </li>
          ))}
        </ul>
        <div className="datasets-about__result">
          <span className="datasets-about__divider" aria-hidden="true" />
          <p className="datasets-about__result-text cgt-body-lg">
            <strong>{about.result.label}</strong> {about.result.text}
          </p>
        </div>
      </div>
    </section>
  )
}

About.propTypes = {
  about: shape({
    title: string.isRequired,
    steps: arrayOf(shape({ title: string.isRequired, text: string.isRequired })).isRequired,
    result: shape({ label: string.isRequired, text: string.isRequired }).isRequired,
  }).isRequired,
}

export default About
